import Actions from '.';
import { get } from '../../../utils/api';
import { API_ERROR_MESSAGE, DEFAULT_RECORD_LIMIT } from '../../../constants';

const getPayments = () => (async (dispatch, getState) => {
    const { products: { page } } = getState();
    dispatch(Actions.updateProperty('loading', true));
    try {
        const data = await get(`payments?pageNumber=${page}&itemsPerPage=${DEFAULT_RECORD_LIMIT}`);
        if (data.statusCode === 200) {
            dispatch(Actions.updateProperties({
                loading: false,
                error: '',
                success: true,
                data: data.response.products || [],
                nextPage: data.response.nextPage,
            }));
        } else {
            dispatch(Actions.updateProperties({
                loading: false,
                error: data.message || API_ERROR_MESSAGE,
                data: [],
            }));
        }
    } catch (e) {
        dispatch(Actions.updateProperties({
            loading: false,
            error: e.message || API_ERROR_MESSAGE,
            data: [],
        }));
    }
});

export default {
    getPayments,
}